<template>
  <div :class="['main-layout min-h-screen flex flex-col', $_inscriptionFormMixin_routesStatus.includes($route.name) ? 'bg-[#181733]' : null]">
    <div :class="['h-100', $_inscriptionFormMixin_routesStatus.includes($route.name) ? 'lg:max-w-[1440px] min-h-screen flex justify-center items-center flex-wrap mx-auto w-full' : null]">
      <TheHeader />
      <TheLoader />
      <router-view />
      <TheFooter />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import TheHeader from '@/layouts/TheHeader.vue'
import TheFooter from '@/layouts/TheFooter.vue'
import TheLoader from '@/components/feedback/TheLoader.vue'
import { useDynamicFormStore } from '@/store/dynamicFormStore'
import { useProjectStore } from '@/store/projectStore.js'
import inscriptionFormMixin from '@/shared/utils/mixins/inscriptionFormMixin.js'

export default {
  name: 'MainLayout',
  components: {
    TheHeader,
    TheFooter,
    TheLoader,
  },
  mixins: [inscriptionFormMixin],
  computed: {
    ...mapState(useDynamicFormStore, { dynamicFormTemplate: 'dataUser' }),
    ...mapState(useProjectStore, ['project']),
  },
  watch: {
    dynamicFormTemplate: {
      handler() {
        this.setTheme()
      },
      deep: true
    }
  },
  created() {
    this.setTheme()
  },
  methods: {
    setTheme() {
      const template = this.dynamicFormTemplate
      const root = document.documentElement
      
      // Configurar colores primarios y secundarios
      if (template?.primaryColor) {
        root.style.setProperty('--theme-primary', template.primaryColor)
      } else {
        root.style.setProperty('--theme-primary', '#465FFF') // blue-600 por defecto
      }
      
      if (template?.secondaryColor) {
        root.style.setProperty('--theme-secondary', template.secondaryColor)
      } else {
        root.style.setProperty('--theme-secondary', '#3B82F6') // dont use gray-600 by deafault use primary of tailwind
      }

      root.style.setProperty('--color-warning-300', '#FEC84B')
    },
  },
}
</script>
<style lang="scss" scoped>
.main-layout {
  @media (min-width: 960px) {
    .v-container {
      max-width: 1440px;
    }
  }
}

// CSS custom properties para colores del tema
:root {
  --theme-primary: #3B82F6; /* blue-600 por defecto */
  --theme-secondary: #6B7280; /* gray-600 por defecto */
}
</style>
